"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecipientCountryId = exports.getRecipientId = exports.gerRecipientIsUnsubscribed = exports.gerRecipientEmailIsValid = exports.getRecipientErrors = exports.getRecipientIsLoading = exports.getRecipient = exports.getRecipientState = void 0;

var R = _interopRequireWildcard(require("ramda"));

var getRecipientState = R.path(['createGift', 'recipient']);
exports.getRecipientState = getRecipientState;
var getRecipient = R.compose(R.prop('recipient'), getRecipientState);
exports.getRecipient = getRecipient;
var getRecipientIsLoading = R.compose(function (_ref) {
  var isLoading = _ref.isLoading,
      isTryLoading = _ref.isTryLoading;
  return isLoading || isTryLoading;
}, getRecipientState);
exports.getRecipientIsLoading = getRecipientIsLoading;
var getRecipientErrors = R.compose(R.prop('errors'), getRecipientState);
exports.getRecipientErrors = getRecipientErrors;
var gerRecipientEmailIsValid = R.compose(R.prop('emailValid'), getRecipientState);
exports.gerRecipientEmailIsValid = gerRecipientEmailIsValid;
var gerRecipientIsUnsubscribed = R.compose(R.prop('isUnsubscribed'), getRecipientState);
exports.gerRecipientIsUnsubscribed = gerRecipientIsUnsubscribed;
var getRecipientId = R.compose(function (recipient) {
  return recipient ? recipient.id : null;
}, getRecipient);
exports.getRecipientId = getRecipientId;
var getRecipientCountryId = R.compose(function (recipient) {
  return recipient ? recipient.countryId : null;
}, getRecipient);
exports.getRecipientCountryId = getRecipientCountryId;